module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_12.de923bc6.png";